import { useEffect } from 'react';
import { useDataModel } from '@thd-nucleus/data-sources';
import _first from 'lodash/first';
import { getMappedSkus } from '../sagas/pricingSaga/_utils';
import isPreviewProduct from '../utils/isPreviewProduct';

const useNucleusData = ({
  storeId, itemId, zipCode, skuMap, itemIdForDisplay
}) => {

  const productOptions = {
    skip: storeId === '8119' || !itemId || !skuMap.isValid,
    ssr: false,
    variables: {
      itemId: String(itemId),
      storeId,
      zipCode,
    }
  };

  let productOptionsForNonSpecialOrders = null;
  if (!skuMap.isSpecialOrder) {
    const skuNumbers = getMappedSkus(skuMap);
    const id = _first(skuNumbers);
    if (id) {
      productOptionsForNonSpecialOrders = {
        skip: storeId === '8119' || itemIdForDisplay <= 0 || !skuMap.isValid,
        variables: {
          itemId: itemIdForDisplay > 0 ? String(itemIdForDisplay) : String(id),
          storeId,
          zipCode,
        }
      };
    }
  }

  // For products that have state => skuMap.isSpecialOrder = false, we have a different way of determining the itemIds
  // to send to graphql. But not all products work this way. We have some that are non-sku-map and isSpecialOrder = false.
  // For those, we should use the standard method of finding itemId. Unfortunately, there is no real way to know if something
  // is a non-sku-map and isSpecialOrder = false product. In this case, we try the isSpecialOrder = false method and it will
  // return no results. Then we try the standard method.
  const { data, loading, error } = useDataModel('clientOnlyProduct', productOptionsForNonSpecialOrders ?? productOptions);

  const anchorItemId = productOptionsForNonSpecialOrders?.variables?.itemId ?? productOptions?.variables?.itemId;

  // prevent MA re-render showing the bubybox-fulfillment
  useEffect(() => {
    if (isPreviewProduct) {
      const payload = { items: null };
      LIFE_CYCLE_EVENT_BUS.trigger('configurator.configurator_available_items', payload);
      // Also emit via the replaying (ReplaySubject-backed) channel -- Buybox subscribes to
      // this event via the lifeCycle channel to survive mounting after this effect fires.
      LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('configurator.configurator_available_items', payload);
      return;
    }

    const payload = {
      items: [{
        itemId: anchorItemId,
        isAnchor: true,
      }]
    };
    LIFE_CYCLE_EVENT_BUS.trigger('configurator.configurator_available_items', payload);
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('configurator.configurator_available_items', payload);
  }, [anchorItemId]);

  return { data, loading, error };
};

export default useNucleusData;
